import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import SectionHeading from "./SectionHeading";

const SectionWrapper = ({ children, rightComponent, heading }) => {
  return (
    <Box>
      <Flex justifyContent={"space-between"} alignItems={"center"} mb={4}>
        <SectionHeading>{heading}</SectionHeading>
        {rightComponent}
      </Flex>
      <Box>{children}</Box>
    </Box>
  );
};

export default SectionWrapper;
